/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { PagesCmsModule } from './cms/cms.module';
import { PagesGestioneOperaModule } from './gestione-opera/gestione-opera.module';
import { PagesGestioneProgettoModule } from './gestione-progetto/gestione-progetto.module';
import { PagesGestioneAnagraficaModule } from './gestione-anagrafica/gestione-anagrafica.module';
import { PagesGestioneRilievoModule } from './gestione-rilievo/gestione-rilievo.module';
import { PagesGestioneUtenteModule } from './gestione-utente/gestione-utente.module';
import { PagesHomeComponent } from './home/home.component';
import { PagesSystemModule } from './system/system.module';
import { PagesViewerComponent } from './viewer/viewer.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        SharedModule,
        PagesCmsModule,
        PagesGestioneOperaModule,
        PagesGestioneAnagraficaModule,
        PagesGestioneProgettoModule,
        PagesGestioneRilievoModule,
        PagesGestioneUtenteModule,
        PagesSystemModule,
    ],
    declarations: [
        PagesHomeComponent,
        PagesViewerComponent,
    ],
    exports: [
        PagesHomeComponent,
        PagesViewerComponent,
    ],
})
export class PagesModule { }
